// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { getApiUrl } from "utils";
import { API_URL } from "constants/api";

// Define a service using a base URL and expected endpoints
export const accountApi = createApi({
  reducerPath: "accounts",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getVerifiedContracts: builder.query<any, { offset: number; limit: number }>(
      {
        query: ({ offset, limit }) =>
          `contract/list?offset=${offset}&limit=${limit}`,
      }
    ),
    getSolidityVer: builder.query<any, string>({
      query: (compiler_type) =>
        `contract/version?compiler_type=${compiler_type}`,
    }),
    getAccountInfo: builder.query<any, string>({
      query: (address) => `address/info?address=${address}`,
      keepUnusedDataFor: 0,
    }),
    getAccountTxs: builder.query<
      any,
      { address: string; offset: number; limit: number }
    >({
      query: ({ address, offset, limit }) =>
        `address/txs?address=${address}&offset=${offset}&limit=${limit}`,
    }),
    getAccountTokenTransfer: builder.query<
      any,
      { address: string; offset: number; limit: number; type?: string }
    >({
      query: ({ address, offset, limit, type }) =>
        `address/transfer?address=${address}&offset=${offset}&limit=${limit}${
          type ? `&type=${type}` : ""
        }`,
    }),
    getAccountTokenList: builder.query<any, string>({
      query: (address) => `address/tokens?address=${address}`,
    }),
    getAccountNftList: builder.query<any, string>({
      query: (address) => `address/nfts?address=${address}`,
    }),
    getTokensInAccount: builder.query<
      any,
      { address: string; offset: number; limit: number }
    >({
      query: ({ address, offset, limit }) =>
        `address/tokens?address=${address}&offset=${offset}&limit=${limit}`,
    }),
    getNftsInAccount: builder.query<
      any,
      { address: string; offset: number; limit: number }
    >({
      query: ({ address, offset, limit }) =>
        `address/nfts?address=${address}&offset=${offset}&limit=${limit}`,
    }),
    getTxsNumber: builder.query<any, {}>({
      query: (list_address) => ({
        url: `contract/txs_statistic`,
        method: "POST",
        body: list_address,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAccountInfoQuery,
  useGetAccountTxsQuery,
  useGetAccountTokenTransferQuery,
  useGetAccountTokenListQuery,
  useGetAccountNftListQuery,
  useGetTokensInAccountQuery,
  useGetNftsInAccountQuery,
  useGetSolidityVerQuery,
  useGetVerifiedContractsQuery,
  useGetTxsNumberQuery,
} = accountApi;
